<template>
  <div>
    <UlSelect
      :id="`${$attrs.id}__input`"
      :disabled="disabled"
      :hint="message"
      :label="label"
      :options="languageList"
      :value="value"
      hide-details="auto"
      @change="$emit('input', $event)"
    >
      <template #optionPrepend="{ item }">
        <v-img
          :src="$asset(`img/countryFlags/${getFlagImage(item.countryCode)}.svg`)"
          class="mr-2"
          contain
          max-width="16px"
        />
      </template>
      <template #optionTitle="{ item }">
        {{ item.value }}
      </template>
      <template #selection="{ item }">
        <v-img
          :src="$asset(`img/countryFlags/${getFlagImage(item.countryCode)}.svg`)"
          class="mr-2"
          contain
          max-width="16px"
        />
        {{ item.value }}
      </template>
    </UlSelect>
  </div>
</template>

<script>
import formValidation from '@/mixins/formValidation';
export default {
  name: 'LanguageSelector',
  mixins: [formValidation],
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    languageList: {
      type: Array,
      required: true
    },
    message: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      required: true
    }
  }
};
</script>
